import { useEffect, useState } from "react";

export function useKeyboardViewport() {
  const [state, setState] = useState({ height: null, open: false });

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const update = () => {
      const open = window.innerHeight - vv.height > 120;
      setState({ height: vv.height, open });
      window.scrollTo(0, 0);
    };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return state;
}
